const isDesktop = () => {
    return window.innerWidth >= 651;
};

const isMobile = () => !isDesktop();

module.exports = {
    isDesktop,
    isMobile,
};
